import Styles from './WriterToolbar.module.scss'
import * as Layout from 'components/Layout'

export const WriterToolbar = () => (
  <div className={Styles.topToolbar} data-testid="top-toolbar">
    <Layout.WriterToolbarContainer />
  </div>
)
